import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, catchError, map, throwError } from 'rxjs';

import { CREATE_OPEN_TITLE_SESSION } from '@graphql/mutations/orders.mutations';
import {
  LIST_MY_ORDERS,
  LIST_ACTIVE_ONE_TIME_USE_PRODUCTS,
} from '@graphql/queries/orders.queries';

import {
  ICreateOpenTitleSessionInput,
  ICreateOpenTitleSessionResult,
  IListActiveOneTimeUseProductsInput,
  IListActiveOneTimeUseProductsResult,
  IListMyOrdersInput,
  IListMyOrdersResult,
} from '@shared/models/orders';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  constructor(private apollo: Apollo) {}

  createOpenTitleSession(
    input: ICreateOpenTitleSessionInput
  ): Observable<ICreateOpenTitleSessionResult> {
    return this.apollo
      .mutate({
        mutation: CREATE_OPEN_TITLE_SESSION,
        variables: input,
      })
      .pipe(
        map((result) => result.data as ICreateOpenTitleSessionResult),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  listActiveOneTimeUseProducts(
    input: IListActiveOneTimeUseProductsInput
  ): Observable<IListActiveOneTimeUseProductsResult> {
    return this.apollo
      .query({ query: LIST_ACTIVE_ONE_TIME_USE_PRODUCTS, variables: input })
      .pipe(
        map((result) => result.data as IListActiveOneTimeUseProductsResult)
      );
  }

  listMyOrders(input: IListMyOrdersInput): Observable<IListMyOrdersResult> {
    return this.apollo
      .query({ query: LIST_MY_ORDERS, variables: input })
      .pipe(map((result) => result.data as IListMyOrdersResult));
  }
}
